import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RequiredAsterisk, FieldValidationErrorMsg } from '../../../sitel/demon/ui/atoms/form';
import { covidVaxNBoosterFormFields } from '../../../services/formFields';
import NavigationButtons from './components/navigationButtons';
import TextAreaReligious from './components/textAreaReligious';
import TextAreaReligiousAdditionalInfo from './components/textAreaReligiousAdditionalInfo';
import useFormSubmit from './components/useFormSubmit';

//https://codesandbox.io/s/checkbox-min-checked-forked-0tkjz?file=/src/App.js -> handle radio

const schema = yup.object({
  [covidVaxNBoosterFormFields.religiousBelief.key]: yup.string().required('This field must be filled'),
  [covidVaxNBoosterFormFields.howReligiousBeliefRestricts.key]: yup.string().required('This field must be filled'),
  [covidVaxNBoosterFormFields.howReligiousBeliefPrevents.key]: yup.string().required('This field must be filled'),
  [covidVaxNBoosterFormFields.fluExempt.key]: yup.string().required('This field must be filled'),
  [covidVaxNBoosterFormFields.sameFluExempt.key]: yup.string(),
  [covidVaxNBoosterFormFields.isAllVaxExempt.key]: yup.string('This field must be filled').required('This field must be filled').nullable(),
  [covidVaxNBoosterFormFields.whyReligiousPrevents.key]: yup.string('This field must be filled'),
});

export default function RelCovidVaxBoosterForm({ exemptionType, requestId, fieldsJSON, moreInfoFieldsJSON}) {
  const defaultValues = fieldsJSON;

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({ resolver: yupResolver(schema), defaultValues });

  const [shownHidesameFluExempt, setShoenHidesameFluExempt] = useState(true);
  const [shownHidewhyReligiousPrevents, setShoenHidewhyReligiousPrevents] = useState(false);
  const onSubmit = useFormSubmit(exemptionType, requestId);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container className='mt-1 mt-md-5'>
        <TextAreaReligious defaultValues={defaultValues} id={covidVaxNBoosterFormFields.religiousBelief.key} labelText={covidVaxNBoosterFormFields.religiousBelief.label} register={register} errors={errors} showIsRequired />

        <TextAreaReligious defaultValues={defaultValues} id={covidVaxNBoosterFormFields.howReligiousBeliefRestricts.key} labelText={covidVaxNBoosterFormFields.howReligiousBeliefRestricts.label} register={register} errors={errors} showIsRequired />

        <TextAreaReligious defaultValues={defaultValues} id={covidVaxNBoosterFormFields.howReligiousBeliefPrevents.key} labelText={covidVaxNBoosterFormFields.howReligiousBeliefPrevents.label} register={register} errors={errors} showIsRequired />

        <div className='form-group row align-items-start py-3 p-md-2 mt-3'>
          <label className='col-md-6 col-form-label pt-0'>
            {covidVaxNBoosterFormFields.fluExempt.label}
            <RequiredAsterisk />
          </label>
          <div className='col-md-6'>
            <div className='form-check'>
              <input className='form-check-input' onClick={() => setShoenHidesameFluExempt(true)} type='radio' name={covidVaxNBoosterFormFields.fluExempt.key} id='fluExemptYes' value='Yes' {...register(covidVaxNBoosterFormFields.fluExempt.key)} checked />
              <label className='form-check-label' htmlFor='fluExemptYes'>
                Yes
              </label>
            </div>
            <div className='form-check'>
              <input className='form-check-input' onClick={() => setShoenHidesameFluExempt(false)} type='radio' name={covidVaxNBoosterFormFields.fluExempt.key} id='fluExemptNo' value='No' {...register(covidVaxNBoosterFormFields.fluExempt.key)} />
              <label className='form-check-label' htmlFor='fluExemptNo'>
                No
              </label>
            </div>
          </div>
        </div>

        {shownHidesameFluExempt && (
          <div className='form-group row align-items-start py-3 p-md-2'>
            <label className='col-md-6 col-form-label pt-0'>
              {covidVaxNBoosterFormFields.sameFluExempt.label}
              <RequiredAsterisk />
            </label>
            <div className='col-md-6'>
              <div className='form-check'>
                <input className='form-check-input' type='radio' name={covidVaxNBoosterFormFields.sameFluExempt.key} id='sameFluExemptYes' value='Yes' {...register(covidVaxNBoosterFormFields.sameFluExempt.key)} checked />
                <label className='form-check-label' htmlFor='sameFluExemptYes'>
                  Yes
                </label>
              </div>
              <div className='form-check'>
                <input className='form-check-input' type='radio' name={covidVaxNBoosterFormFields.sameFluExempt.key} id='sameFluExemptNo' value='No' {...register(covidVaxNBoosterFormFields.sameFluExempt.key)} />
                <label className='form-check-label' htmlFor='sameFluExemptNo'>
                  No
                </label>
              </div>
            </div>
          </div>
        )}

        <div className='form-group row align-items-start py-3 p-md-2'>
          <label className='col-md-6 col-form-label pt-0'>
            {covidVaxNBoosterFormFields.isAllVaxExempt.label}
            <RequiredAsterisk />
          </label>
          <div className='col-md-6'>
            <div className='form-check'>
              <input className='form-check-input' onClick={() => setShoenHidewhyReligiousPrevents(false)} type='radio' name={covidVaxNBoosterFormFields.isAllVaxExempt.key} id='isAllVaxExemptAll' value='All other vaccines' {...register(covidVaxNBoosterFormFields.isAllVaxExempt.key)} />
              <label className='form-check-label' htmlFor='isAllVaxExemptAll'>
                All other vaccines
              </label>
            </div>

            <div className='form-check'>
              <input className='form-check-input' onClick={() => setShoenHidewhyReligiousPrevents(false)} type='radio' name={covidVaxNBoosterFormFields.isAllVaxExempt.key} id='isAllVaxExemptSome' value='Some, but not all vaccines' {...register(covidVaxNBoosterFormFields.isAllVaxExempt.key)} />
              <label className='form-check-label' htmlFor='isAllVaxExemptSome'>
                Some, but not all vaccines
              </label>
            </div>

            <div className='form-check'>
              <input className='form-check-input' onClick={() => setShoenHidewhyReligiousPrevents(true)} type='radio' name={covidVaxNBoosterFormFields.isAllVaxExempt.key} id='isAllVaxExemptOnlyCovid' value='Only the COVID-19 vaccines' {...register(covidVaxNBoosterFormFields.isAllVaxExempt.key)} />
              <label className='form-check-label' htmlFor='isAllVaxExemptOnlyCovid'>
                Only the COVID-19 vaccines
              </label>
            </div>

            <FieldValidationErrorMsg field={covidVaxNBoosterFormFields.isAllVaxExempt.key} errors={errors} />
          </div>
        </div>

        {shownHidewhyReligiousPrevents && <TextAreaReligious defaultValues={defaultValues} id={covidVaxNBoosterFormFields.whyReligiousPrevents.key} labelText={covidVaxNBoosterFormFields.whyReligiousPrevents.label} register={register} errors={errors} showIsRequired />}

        <TextAreaReligiousAdditionalInfo moreInfoRequest={moreInfoFieldsJSON} register={register} errors={errors} />
        
      </Container>
      <NavigationButtons isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful}/>
    </form>
  );
}
